import { Component } from '@angular/core';

@Component({
  selector: 'flex-privacy-policy-navbar',
  imports: [],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {

}
